// extracted by mini-css-extract-plugin
export default {"row":"Fyncu","colTicket":"QtJzM","colSeatInfo":"sbz9M","colTotal":"_6tIcX","ticketDetailsHeader":"SB2DX","firstSeatingCol":"EGad5","secondSeatingCol":"_7CdZd","colSeating":"NALr9"};